import { Button } from '@talentmesh/ui/components/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@talentmesh/ui/components/dialog';
import useChangesMaybeLostDialog from './useChangesMaybeLostDialog';
import UIStrings from '@/Utils/UIStrings';

function ChangesMaybeLostDialog() {
    const { show, leaveHandler, stayHandler } = useChangesMaybeLostDialog();

    return (
        <Dialog
            open={show}
            onOpenChange={(open) => {
                if (!open) {
                    stayHandler();
                }
            }}
        >
            <DialogContent className="max-w-sm">
                <DialogHeader>
                    <DialogTitle>{UIStrings.AreYouSure}</DialogTitle>
                </DialogHeader>
                <p className="text-foreground text-sm">{UIStrings.AreYouSureYouWantToLeaveWithoutSendingInvites}</p>
                <DialogFooter className="flex-col gap-4 sm:flex-row">
                    <Button type="button" variant="outline" className="flex-1" onClick={leaveHandler}>
                        {UIStrings.LeaveThePage}
                    </Button>
                    <Button type="button" className="flex-1" onClick={stayHandler}>
                        {UIStrings.Stay}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default ChangesMaybeLostDialog;
